import { lt } from '@mews/framework';
import { IconName, Tag } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { SpacedLeftParenthesis } from '@mews-commander/ui';
import { getLoyaltyMembershipName } from '@mews-commander/utils';
import { WithPrimaryFlag } from './types';

interface LoyaltyMembershipTagProps extends WithPrimaryFlag {
    markPrimary?: boolean;
    programName: string;
    tierName: string;
}

export const LoyaltyMembershipTag = ({ isPrimary, markPrimary, programName, tierName }: LoyaltyMembershipTagProps) => (
    <Tag leadingIcon={IconName.Loyalty} variant="basicSubtle">
        {getLoyaltyMembershipName({ programName, tierName })}
        {markPrimary && isPrimary ? (
            <>
                {SpacedLeftParenthesis}
                {lt('GuestInHouseReportLoyaltyProgramPrimaryLabel')}
                {UnicodeEntity.RightParenthesis}
            </>
        ) : null}
    </Tag>
);
